import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style/AdminPanel.css';

function AdminPanel() {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('adminAuth');
        localStorage.removeItem('loginTime');
        window.location.href = '/panel/admin-login';
    };

    return (
        <div className="admin-panel">
            <header className="admin-header">
                <h1>Админ-панель</h1>
                <p>Добро пожаловать, Администратор!</p>
                {/* 🔴 Кнопка выйти */}
                <button className="logout-btn" onClick={handleLogout}>
                    Выйти
                </button>
            </header>

            <section className="admin-content">
                <div className="admin-card">
                    <h3>Управление пользователями</h3>
                    <p>Добавление, удаление и редактирование данных пользователей.</p>
                    <button onClick={() => navigate('/panel/user-management')}>
                        Перейти
                    </button>
                </div>

                <div className="admin-card">
                    <h3>Дискорд-карты</h3>
                    <p>Просмотр и редактирование списка дискорд-карт.</p>
                    <button onClick={() => navigate('/panel/disc-card')}>
                        Перейти
                    </button>
                </div>

                <div className="admin-card">
                    <h3>Страховые компании</h3>
                    <p>Управление страховыми компаниями и их тарифами.</p>
                    <button onClick={() => navigate('/panel/companies-mng-panel')}>
                        Перейти
                    </button>
                </div>

                <div className="admin-card">
                    <h3>Шаблоны автомобилей</h3>
                    <p>Загрузка и управление шаблонами авто (бренды, модели, годы, цены).</p>
                    <button onClick={() => navigate('/panel/cars-templates-panel')}>
                        Перейти
                    </button>
                </div>
                <div className="admin-card">
                    <h3>Услуги</h3>
                    <p>Просмотр и обработка входящих клиентских заявок.</p>
                    <button onClick={() => navigate('/panel/service-mng-panel')}>
                        Перейти
                    </button>
                </div>
                <div className="admin-card">
                    <h3>Заявки</h3>
                    <p>Просмотр и обработка входящих клиентских заявок.</p>
                    <button onClick={() => navigate('/panel/orders-panel')}>
                        Перейти
                    </button>
                </div>
                <div className="admin-card">
                    <h3>Новости</h3>
                    <p>Просмотр и обработка новости</p>
                    <button onClick={() => navigate('/panel/news-admin')}>
                        Перейти
                    </button>
                </div>
            </section>



            <footer className="admin-footer">
                <p>© 2025 АвтоСервис. Панель администратора</p>
            </footer>
        </div>
    );
}

export default AdminPanel;
